import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Loading from "../shared/Loading";
import IDocument from "../../models/IDocument";
import IDocumentEdited from "../../models/IDocumentEdited";
import { Button, TextField } from "@material-ui/core";
import ICategory from "../../models/ICategory";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            marginBottom: theme.spacing(4),
            minWidth: 120,
            verticalAlign: "middle"
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        loading: {
            margin: theme.spacing(8),
            textAlign: "center"
        }
    })
);

interface IEditDocumentDialog {
    open: boolean;
    document: IDocument;
    saving: boolean;
    handleCancel(event: React.MouseEvent): void;
    handleSave(document: IDocumentEdited): void;
    categories: ICategory[] | null;
}

const EditDocumentDialog: React.FC<IEditDocumentDialog> = ({
    open,
    handleCancel,
    handleSave,
    saving,
    document,
    categories
}) => {
    const classes = useStyles();

    const [description, setDescription] = React.useState<string>(
        document.description
    );
    const [title, setTitle] = React.useState<string>(document.title);
    const [categoryId, setCategory] = React.useState<number>(document.type);

    const onDescriptionChange = event => {
        setDescription(event.target.value);
    };

    const onTitleChange = event => {
        setTitle(event.target.value);
    };

    const getTitleFieldHelperText = () => {
        if (title === "") {
            return "A title is required.";
        }

        return "This value is visible to all users.";
    };

    const onCategoryChange = event => {
        setCategory(event.target.value);
    };

    const categoryOptions =
        categories != null && open ? (
            categories.map(item => {
                return <option value={item.id}>{item.name}</option>;
            })
        ) : (
            <></>
        );

    return (
        <div>
            <Dialog
                open={open}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle id="form-dialog-title">Edit document</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {saving ? "Saving..." : `${document.title}`}
                    </DialogContentText>
                    {saving ? (
                        <div className={classes.loading}>
                            <Loading />
                        </div>
                    ) : (
                        <FormGroup>
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="type-native-simple">
                                    Category
                                </InputLabel>
                                <Select
                                    native
                                    inputProps={{
                                        name: "type",
                                        id: "type-native-simple"
                                    }}
                                    onChange={onCategoryChange}
                                    value={categoryId}
                                >
                                    {categoryOptions}
                                </Select>
                            </FormControl>

                            <TextField
                                type="text"
                                onChange={onTitleChange}
                                placeholder="Document title"
                                label="Document Title"
                                error={title === ""}
                                value={title}
                                helperText={getTitleFieldHelperText()}
                            />

                            <TextField
                                multiline
                                rowsMax={4}
                                label="Document Description"
                                placeholder="Document descrption"
                                rows={4}
                                type="text"
                                onChange={onDescriptionChange}
                                value={description}
                                helperText="This value is visible to all users."
                            />
                        </FormGroup>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="primary">
                        Cancel
                    </Button>
                    {!saving ? (
                        <Button
                            onClick={() => {
                                handleSave({
                                    id: document.id,
                                    description: description,
                                    type: categoryId,
                                    title: title
                                });
                            }}
                            color="primary"
                            disabled={title === ""}
                        >
                            Save
                        </Button>
                    ) : (
                        <></>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default EditDocumentDialog;
